import { Navigate } from '@sorare/routing';
import { ANY_SPORT_SERIES_ONBOARDING_WELCOME } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const LegacyWelcomePage = () => {
  const { generateSportContextPath } = useSportContext();
  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_SERIES_ONBOARDING_WELCOME)}
      keepSearchParams
      replace
    />
  );
};

export default LegacyWelcomePage;
